import { ExternalLink, MapPin, MessageCircle, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function BatchwoodLocation() {
  return <section id="batchwoodcentrelocation" data-nav="light" className="bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight">
            Find us at Batchwood Golf and Sports Centre
          </h2>
        </div>

        <Card className="rounded-3xl border border-border bg-card shadow-sm overflow-hidden py-0">
          <CardContent className="p-6 sm:p-8 md:p-10 space-y-8">
            {/* Address details */}
            <div className="flex items-start gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <MapPin className="size-5" />
              </div>
              <div>
                <h3 className="font-semibold text-lg text-foreground mb-1">
                  PhysAnalytica at Batchwood Golf and Sports Centre
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  Batchwood Drive, St Albans, AL3 5XA
                </p>
              </div>
            </div>

            {/* Action buttons */}
            <div className="flex flex-wrap items-center gap-3 pt-2 border-t border-border">
              <Button asChild size="lg" className="rounded-xl">
                <Link to="https://physiogenics.uk3.cliniko.com/bookings?business_id=1933385715966552600" newTab>
                  Book Batchwood
                </Link>
              </Button>

              <Button asChild variant="outline" size="lg" className="rounded-xl">
                <a href="tel:+447916538694">
                  <Phone className="size-4" />
                  Call
                </a>
              </Button>

              <Button asChild variant="secondary" size="lg" className="rounded-xl">
                <Link to="https://wa.me/447916538694" newTab>
                  <MessageCircle className="size-4" />
                  WhatsApp Us
                </Link>
              </Button>
            </div>

            {/* Embedded map */}
            <div className="overflow-hidden rounded-2xl border border-border aspect-16/10 sm:aspect-21/9 w-full bg-muted">
              <iframe title="PhysAnalytica Batchwood Clinic Map" src="https://www.google.com/maps?q=Batchwood+Golf+and+Sports+Centre,+Batchwood+Drive,+St+Albans,+AL3+5XA&output=embed" width="100%" height="100%" className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>

            {/* Partnership details & centre link */}
            <div className="border-t border-border pt-6 space-y-4">
              <p className="text-sm leading-relaxed text-muted-foreground">
                PhysAnalytica is an independent healthcare provider operating from the centre. Everyone Active manages the leisure facility but does not provide PhysAnalytica&apos;s clinical services.
              </p>

              <p className="text-sm leading-relaxed text-muted-foreground">
                PhysAnalytica&apos;s Batchwood clinic operates in partnership with Physiogenics. Physiogenics runs and manages patients&apos; healthcare and wellbeing at this location, while PhysAnalytica provides specialist biomechanics expertise and support across all services delivered here.
              </p>

              <div>
                <Link to="https://www.everyoneactive.com/centre/batchwood-golf-and-sports-centre/" newTab className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:text-primary/80 transition-colors underline underline-offset-4">
                  <span>View Batchwood Golf and Sports Centre</span>
                  <ExternalLink className="size-4" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}